export const ASSISTANT_ATTACHMENT_PREFIX = 'att' as const;
export const ASSISTANT_ATTACHMENT_ID_GLUE = '_' as const;

export type AssistantAttachmentId =
  `${typeof ASSISTANT_ATTACHMENT_PREFIX}${typeof ASSISTANT_ATTACHMENT_ID_GLUE}${string}`;
